import {useContext} from 'react'

import type {GetProblemOccurrenceTreeApiArg} from '../../../../services/rest'

import {BuildProblemsTreeContext} from './BuildProblemsTree.context'

export function useBuildProblemsTreeArg(locator: string): GetProblemOccurrenceTreeApiArg {
  const {locatorInEndpoint, getEndpoint} = useContext(BuildProblemsTreeContext)
  return {
    endpoint: getEndpoint(locator),
    locator: locatorInEndpoint ? null : locator,
    treeLocator: locator,
  }
}
